import { Dialog } from '@mui/material';
import React from 'react';
import styles from "../styles.module.scss";
import TickIcon from "assets/img/svg/svgComponents/TickIcon";
import AButton from '../../../../../views/pages/manage/common/form-fields-mui/AButton';
import { useHistory } from "react-router-dom";
import { getFormatedDate } from '../../../../../views/pages/manage/unAssigned/concessionApproval/common';

const RectRefundInitSuccessDialog = ({
    dialogInfo = {}
}) => {

    const { isOpen, refundNumber, createdBy, createdOn, approverId, approverName, multipleRefundsRaised } = dialogInfo;
    const history = useHistory();

    const [createdOnDate, createdOnTime] = getFormatedDate(createdOn, false, "DD/MM/YYYY, hh:mm A")?.split(",");

    return (
        <Dialog
            open={isOpen}
            sx={{
                "& .MuiDialog-container": {
                    "& .MuiPaper-root": {
                        width: "100%",
                        maxWidth: "570px",
                    },
                },
            }}
        >
            <div className={styles['rect-refund-init-success-dialog']}>
                <span className={`d-flex justify-content-center align-items-center ${styles['tick-icon']}`}><TickIcon /></span>
                <div className={styles['header']}>Refund{multipleRefundsRaised && "s"} {refundNumber} {multipleRefundsRaised ? "have" : "has"} been initiated and sent for approval.</div>
                <div className={styles['subHeader']}>Please check the dashboard for tracking refund status</div>
                <AButton
                    variant='primary_filled'
                    onClick={() => history.push('/admin/refundTracker')}
                    className={`no-ml-btn ${styles['dialog-btn']}`}
                >
                    Go To Refund Tracker
                </AButton>

                <div className={styles['subHeader']}>Raised by {createdBy} on {createdOnDate} at {createdOnTime}</div>
            </div>

        </Dialog>
    );
}

export default RectRefundInitSuccessDialog;